var _rect, _circle, _path, _path2, _path3, _path4, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWaitlistBackground = function SvgWaitlistBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 339,
    height: 412,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 204,
    x: 255,
    y: 171,
    fill: "#8FEFBB",
    rx: 42
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140.3,
    cy: 171.3,
    r: 94.3,
    fill: "#FF80B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m55 39 48 83H7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 5,
    d: "m150 399-95-55 95-55z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D80",
    d: "M271 75h50v50h-50z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 5.8,
    d: "M253 35c0 17-14 31-31 31s-31-14-31-31c0-18 14-32 31-32s31 14 31 32Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47.4,
    cy: 208.8,
    r: 29,
    fill: "#FFEB33"
  })));
};
export { SvgWaitlistBackground as ReactComponent };